import { useMutation, useQueryClient } from '@tanstack/react-query'

import { dataOrThrow, type PatchMeBody } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'
import { meQueryKey } from '@/customer/hooks/use-get-me'

/**
 * Partial update of the signed-in member's profile via
 * `PATCH /api/portal/me`. Invalidates the `me` snapshot on success so
 * downstream reads pick up the new values without a manual refetch.
 *
 * Identifier changes (phone / email) don't go through this hook -
 * they're driven end-to-end by better-auth on the update pages,
 * which writes the new value straight onto the `members` row.
 */
export function useUpdateMe() {
  const api = usePortalApi()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (body: PatchMeBody) => dataOrThrow(await api.patch('/me', { body })),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: meQueryKey })
    },
  })
}
